// The subscription tiers, once (ENTRAID-307, Hugo Andrade 2026-10-25). Shared by the backend and the SPA.
//
// The keys are the AWS Marketplace dimension keys and the portal's `tierName` values; they never change. They are listed
// from the lowest to the highest, so the order is the ranking (lib/marketplace.mjs tierFromEntitlements ranks the same
// way). Only the names shown to people change (approved by Hugo Andrade 2026-09-28, ENTRAID-275), and they must match
// the listing's dimension names exactly. An unset tier is treated as starter everywhere.

export const TIER_KEYS = Object.freeze(['starter', 'professional', 'enterprise']);

/** The highest tier: the one on which IPC Global staff may act as a customer's admin (shared/staff-act.mjs). */
export const TOP_TIER = TIER_KEYS[TIER_KEYS.length - 1];

export const DEFAULT_TIER = TIER_KEYS[0];

const TIER_LABELS = Object.freeze({
  starter: 'Data Collection',
  professional: 'Data Collection + Qlik Apps',
  enterprise: 'Data Collection + Qlik Apps + Expert Hours',
});

/** True for one of TIER_KEYS, by exact match. */
export const isTierKey = (t) => typeof t === 'string' && TIER_KEYS.includes(t);

/** Human-readable tier name. An unset tier is treated as starter; an unknown key is shown as is. */
export function tierLabel(tierName) {
  const key = tierName ?? DEFAULT_TIER;
  return Object.hasOwn(TIER_LABELS, key) ? TIER_LABELS[key] : key;
}
